import { ErrorOption, LiteralUnion, RegisterOptions } from "react-hook-form"

export const getErrorMessage = (
  name: string,
  error:
    | {
        message?: string
        type?: LiteralUnion<keyof RegisterOptions, string>
        shouldFocus?: boolean
      }
    | undefined
) => {
  if (!error) {
    return ""
  }

  switch (error.type) {
    case "required":
      return error.message || `${name} is required.`
    default:
      return error.message || ""
  }
}
